module.exports = __webpack_public_path__ + "static/media/jpg.9aff6d1a.svg";